import AutopayBadge from '../../../assets/autopay-badge.svg';
import RateGeniusBadge from '../../../assets/rategenius-badge.svg';
import TreslBadge from '../../../assets/tresl-badge.svg';

/*
 Keyed on the brand as it is stored on the application, so the keys must match
 those values verbatim (note the inconsistent casing).
*/
export const partnerBadgeAssets: Record<string, string> = {
  AUTOPAY: AutopayBadge,
  RateGenius: RateGeniusBadge,
  Tresl: TreslBadge,
};
